module.exports = __webpack_public_path__ + "img/wifi-block-maple.cd63c539.png";